import { useState, useEffect } from 'react';

export default function Layer() {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        const removeTimer = setTimeout(() => {
            setIsVisible(false);
        }, 3000);

        return () => {
            clearTimeout(removeTimer);
        };
    }, []);

    if (!isVisible) return null;

    return (
        <div className='layer fade-out'>
            <img
                src="/logo-circle.png"
                alt="Logo"
                className='spin'
            />
        </div>
    );
};